/* ============================================
   NIMBA FOODS — HOMEPAGE ANIMATIONS
   GSAP + ScrollTrigger
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a, h2, p').forEach(el => {
    if (el.textContent.includes('First Jar')) {
      el.textContent = el.textContent.replace(/First Jar/g, 'First Order');
    }
    if (el.textContent.includes('first jar')) {
      el.innerHTML = el.innerHTML.replace(/first jar/g, 'first order');
    }
  });

  // Bail out if user prefers reduced motion
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) {
    // Make everything visible immediately
    document.querySelectorAll('.anim-reveal, .anim-reveal-left, .anim-reveal-right, .anim-scale, .sb-plan__step').forEach(el => {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
    document.querySelectorAll('.sb-hero__eyebrow, .sb-hero__title, .sb-hero__sub, .sb-hero__actions, .sb-hero__trust, .sb-hero__product-img').forEach(el => {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  // ============ NAV SCROLL TRANSITION ============
  // Safe-by-default: header starts solid cream in CSS.
  // JS opts INTO transparency only when proven at top (scrollY < 80).
  const header = document.getElementById('nb-header');
  const transparentHero = document.querySelector('.sb-hero');
  let lastScrollY = 0;

  // Suppress transitions on initial load so the first state snaps instantly
  header.style.transition = 'none';

  function updateNav() {
    const scrollY = window.scrollY;
    if (transparentHero && scrollY < 80) {
      header.classList.add('header-transparent');
    } else {
      header.classList.remove('header-transparent');
    }
    lastScrollY = scrollY;
  }

  window.addEventListener('scroll', updateNav, { passive: true });
  updateNav(); // check on load

  // Re-enable transitions after initial paint (double-rAF guarantees first frame rendered)
  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      header.style.transition = '';
    });
  });

  // ============ HERO-READY (defer blur until hero paints) ============
  (function detectHeroReady() {
    var heroBg = document.querySelector('.sb-hero__bg');
    if (!heroBg) { header.classList.add('hero-ready'); return; }

    // Extract the background-image URL
    var style = getComputedStyle(heroBg);
    var match = style.backgroundImage.match(/url\(["']?(.+?)["']?\)/);
    if (!match) { header.classList.add('hero-ready'); return; }

    var img = new Image();
    img.src = match[1];

    if (img.complete && img.naturalWidth > 0) {
      header.classList.add('hero-ready');
    } else {
      img.onload = function() { header.classList.add('hero-ready'); };
      img.onerror = function() { header.classList.add('hero-ready'); };
      // Fallback: add hero-ready after 500ms even if image stalls
      setTimeout(function() { header.classList.add('hero-ready'); }, 500);
    }
  })();

  // ============ HERO ENTRANCE ============
  const heroTl = gsap.timeline({
    defaults: { ease: 'power3.out' },
    delay: 0.2
  });

  heroTl
    .fromTo('.sb-hero__eyebrow',
      { y: 20, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.6 },
      0
    )
    .fromTo('.sb-hero__title',
      { y: 30, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.8 },
      0.15
    )
    .fromTo('.sb-hero__sub',
      { y: 20, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.6 },
      0.4
    )
    .fromTo('.sb-hero__actions',
      { y: 20, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.6 },
      0.6
    )
    .fromTo('.sb-hero__trust',
      { y: 20, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.6 },
      0.8
    )
    .fromTo('.sb-hero__product-img',
      { scale: 0.92, opacity: 0 },
      { scale: 1, opacity: 1, duration: 1, ease: 'power2.out' },
      0.3
    );

  // ============ SCROLL REVEAL: Generic .anim-reveal ============
  gsap.utils.toArray('.anim-reveal').forEach((el) => {
    gsap.fromTo(el,
      { y: 32, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.7,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 88%',
          toggleActions: 'play none none none'
        }
      }
    );
  });

  // ============ SCROLL REVEAL: Left slide ============
  gsap.utils.toArray('.anim-reveal-left').forEach((el) => {
    gsap.fromTo(el,
      { x: -40, opacity: 0 },
      {
        x: 0,
        opacity: 1,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
          toggleActions: 'play none none none'
        }
      }
    );
  });

  // ============ SCROLL REVEAL: Right slide ============
  gsap.utils.toArray('.anim-reveal-right').forEach((el) => {
    gsap.fromTo(el,
      { x: 40, opacity: 0 },
      {
        x: 0,
        opacity: 1,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
          toggleActions: 'play none none none'
        }
      }
    );
  });

  // ============ SCROLL REVEAL: Scale up ============
  gsap.utils.toArray('.anim-scale').forEach((el) => {
    gsap.fromTo(el,
      { scale: 0.95, opacity: 0 },
      {
        scale: 1,
        opacity: 1,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
          toggleActions: 'play none none none'
        }
      }
    );
  });

  // ============ 3-STEP PLAN: Tight stagger ============
  const planSteps = gsap.utils.toArray('.sb-plan__step');
  if (planSteps.length) {
    gsap.fromTo(planSteps,
      { y: 20, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.5,
        stagger: 0.25,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: '.sb-plan',
          start: 'top 70%',
          toggleActions: 'play none none none'
        }
      }
    );
  }

  // ============ BEFORE/AFTER SLIDER ============
  const baSlider = document.getElementById('baSlider');
  const baHandle = document.getElementById('baHandle');
  if (baSlider && baHandle) {
    let isDragging = false;

    function updateSlider(clientX) {
      const rect = baSlider.getBoundingClientRect();
      let x = (clientX - rect.left) / rect.width;
      x = Math.max(0.05, Math.min(0.95, x));
      const pct = x * 100;
      baSlider.querySelector('.sb-ba__before').style.clipPath = `inset(0 ${100 - pct}% 0 0)`;
      baHandle.style.left = pct + '%';
    }

    baSlider.addEventListener('mousedown', (e) => {
      isDragging = true;
      updateSlider(e.clientX);
      e.preventDefault();
    });

    document.addEventListener('mousemove', (e) => {
      if (isDragging) updateSlider(e.clientX);
    });

    document.addEventListener('mouseup', () => {
      isDragging = false;
    });

    // Touch support
    baSlider.addEventListener('touchstart', (e) => {
      isDragging = true;
      updateSlider(e.touches[0].clientX);
    }, { passive: true });

    document.addEventListener('touchmove', (e) => {
      if (isDragging) updateSlider(e.touches[0].clientX);
    }, { passive: true });

    document.addEventListener('touchend', () => {
      isDragging = false;
    });
  }

  // ============ HERO: Parallax scroll ============
  gsap.to('.sb-hero__bg', {
    yPercent: 30,
    ease: 'none',
    scrollTrigger: {
      trigger: '.sb-hero',
      start: 'top top',
      end: 'bottom top',
      scrub: true,
      invalidateOnRefresh: true
    }
  });

  function refreshHeroScrollState() {
    updateNav();
    if (window.ScrollTrigger) {
      ScrollTrigger.refresh();
    }
  }

  window.addEventListener('load', refreshHeroScrollState, { once: true });
  window.addEventListener('pageshow', refreshHeroScrollState);

  // ============ LAZY VIDEO: Combined src-inject + play ============
  // Below-fold videos use data-src so they do not load until visible.
  function lazyPlayVideo(video) {
    if (video.dataset.src && (!video.src || video.src === window.location.href)) {
      video.src = video.dataset.src;
      video.load();
    }

    if (video.readyState >= 3) {
      video.play().catch(() => {});
    } else {
      video.addEventListener('canplay', function onCanplay() {
        video.removeEventListener('canplay', onCanplay);
        if (video._wantsPlay) video.play().catch(() => {});
      });
    }
    video._wantsPlay = true;
  }

  function lazyPauseVideo(video) {
    video._wantsPlay = false;
    video.pause();
  }

  // Watch & Buy videos — lazy src + autoplay on visibility
  document.querySelectorAll('.sb-watchbuy__video-thumb video').forEach(video => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          lazyPlayVideo(video);
        } else {
          lazyPauseVideo(video);
        }
      });
    }, { threshold: 0.3 });
    observer.observe(video);
  });

  // UGC videos — lazy src + play/pause badge when that markup is present
  document.querySelectorAll('.sb-ugc__item').forEach(container => {
    const video = container.querySelector('video');
    const playBtn = container.querySelector('.sb-ugc__play');
    if (!video) return;

    video.muted = true;

    const syncVideoState = () => {
      container.classList.toggle('sb-ugc__item--paused', video.paused);
      if (playBtn) playBtn.classList.toggle('sb-ugc__play--hidden', !video.paused);
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          lazyPlayVideo(video);
        } else {
          lazyPauseVideo(video);
        }
        syncVideoState();
      });
    }, { threshold: 0.3 });
    observer.observe(video);

    container.addEventListener('click', () => {
      if (video.dataset.src && (!video.src || video.src === window.location.href)) {
        video.src = video.dataset.src;
        video.load();
      }
      if (video.paused) {
        video._wantsPlay = true;
        video.play().then(syncVideoState).catch(() => {
          container.classList.add('sb-ugc__item--paused');
          if (playBtn) playBtn.classList.remove('sb-ugc__play--hidden');
        });
      } else {
        video._wantsPlay = false;
        video.pause();
        syncVideoState();
      }
    });

    video.addEventListener('play', syncVideoState);
    video.addEventListener('playing', syncVideoState);
    video.addEventListener('pause', syncVideoState);
    video.addEventListener('loadeddata', syncVideoState);
    video.addEventListener('canplay', syncVideoState);

    requestAnimationFrame(syncVideoState);
    setTimeout(syncVideoState, 150);
  });

  // ============ HOMEPAGE TRACEABILITY SIMULATION ============
  const traceTrigger = document.querySelector('[data-trace-sim-trigger]');
  const tracePanel = document.querySelector('[data-trace-panel]');
  const traceCamera = document.querySelector('[data-trace-camera]');
  if (traceTrigger && tracePanel && traceCamera) {
    traceTrigger.addEventListener('click', () => {
      const active = tracePanel.classList.toggle('active');
      traceCamera.classList.toggle('is-scanned', active);
      traceTrigger.textContent = active ? 'Reset Simulation' : 'Try Simulation →';
    });
  }

  // ============ S8: PROCESS — FROM TREE TO JAR ============
  const processSection = document.querySelector('.sb-process');
  let slatsPreloaded = false;

  if (processSection) {
    const preloadObserver = new IntersectionObserver((entries) => {
      if (slatsPreloaded) return;
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          slatsPreloaded = true;
          document.querySelectorAll('.sb-process__slat video[data-slat-src]').forEach(v => {
            v.src = v.dataset.slatSrc;
            v.preload = 'metadata';
            v.load();
          });
          preloadObserver.disconnect();
        }
      });
    }, { rootMargin: '500px 0px' });
    preloadObserver.observe(processSection);
  }

  const slats = document.querySelectorAll('.sb-process__slat');
  let activeSlat = document.querySelector('.sb-process__slat.is-active');
  let currentlyPlaying = null;

  function activateSlat(slat) {
    if (slat === activeSlat) return;
    if (currentlyPlaying) {
      currentlyPlaying.pause();
      currentlyPlaying = null;
    }
    slats.forEach(s => s.classList.remove('is-active'));
    slat.classList.add('is-active');
    activeSlat = slat;
    if (!prefersReducedMotion) {
      const video = slat.querySelector('video');
      if (video) {
        if (!video.src && video.dataset.slatSrc) {
          video.src = video.dataset.slatSrc;
          video.load();
        }
        video.play().catch(() => {});
        currentlyPlaying = video;
      }
    }
  }

  slats.forEach(slat => {
    slat.addEventListener('mouseenter', () => activateSlat(slat));
    slat.addEventListener('focus', () => activateSlat(slat));
  });

  if (slats.length > 0) {
    ScrollTrigger.create({
      trigger: '.sb-process__slats',
      start: 'top 80%',
      end: 'bottom 20%',
      onEnter: () => {
        if (!prefersReducedMotion && activeSlat) {
          const v = activeSlat.querySelector('video');
          if (v) {
            if (!v.src && v.dataset.slatSrc) {
              v.src = v.dataset.slatSrc;
              v.load();
            }
            v.play().catch(() => {});
            currentlyPlaying = v;
          }
        }
      },
      onLeave: () => { if (currentlyPlaying) { currentlyPlaying.pause(); currentlyPlaying = null; } },
      onLeaveBack: () => { if (currentlyPlaying) { currentlyPlaying.pause(); currentlyPlaying = null; } },
      onEnterBack: () => {
        if (!prefersReducedMotion && activeSlat) {
          const v = activeSlat.querySelector('video');
          if (v) {
            v.play().catch(() => {});
            currentlyPlaying = v;
          }
        }
      }
    });
  }

  const loomItems = document.querySelectorAll('.sb-process__loom-item');
  let activeLoomVideo = null;

  function playLoomVideo(video) {
    if (prefersReducedMotion) return;
    if (video === activeLoomVideo) return;
    if (activeLoomVideo) activeLoomVideo.pause();
    if (!video.src && video.dataset.loomSrc) {
      video.src = video.dataset.loomSrc;
      video.load();
    }
    video.play().catch(() => {});
    activeLoomVideo = video;
  }

  function pauseLoomVideo(video) {
    video.pause();
    if (activeLoomVideo === video) activeLoomVideo = null;
  }

  loomItems.forEach(item => {
    const video = item.querySelector('video');
    if (!video) return;

    ScrollTrigger.create({
      trigger: item,
      start: 'top 40%',
      end: 'bottom 40%',
      onEnter: () => playLoomVideo(video),
      onEnterBack: () => playLoomVideo(video),
      onLeave: () => pauseLoomVideo(video),
      onLeaveBack: () => pauseLoomVideo(video)
    });
  });

});
